import { types, async } from '~/utils/typeCreator'

export default types(
  [...async('SEARCH_NOTICE_FORMS'), 'CLEAR_STATE'],
  'NOTICE_FORMS'
)
